import React, { useState } from "react";
import { Link } from "react-router-dom";

const TasksPage = () => {
  const [activeTab, setActiveTab] = useState("contacted");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  return (
    <div className="bg-[#ffbe1a23] flex justify-between w-[95%] mt-6 ml-4 px-4 overflow-auto">
      <Link to="/tasks">
        <div
          className={`relative py-4 px-5 text-[12px] cursor-pointer flex justify-center ${
            activeTab === "contacted" ? "active-prospects" : ""
          }`}
          onClick={() => handleTabClick("contacted")}
        >
          Today
          <div
            className={`${activeTab === "contacted" ? "active-underline" : ""}`}
          ></div>
        </div>
      </Link>
      <Link to="/tasks/upcoming">
        <div
          className={`relative py-4 px-5 text-[12px] cursor-pointer flex justify-center ${
            activeTab === "pending" ? "active-prospects" : ""
          }`}
          onClick={() => handleTabClick("pending")}
        >
          Upcoming
          <div
            className={`${activeTab === "pending" ? "active-underline" : ""}`}
          ></div>
        </div>
      </Link>
      <Link to="/tasks/completed">
        <div
          className={`relative py-4 px-5 text-[12px] cursor-pointer flex justify-center ${
            activeTab === "negotiation" ? "active-prospects" : ""
          }`}
          onClick={() => handleTabClick("negotiation")}
        >
          Completed
          <div
            className={`${
              activeTab === "negotiation" ? "active-underline" : ""
            }`}
          ></div>
        </div>
      </Link>
      <Link to="/tasks/all">
        <div
          className={`relative py-4 px-5 text-[12px] cursor-pointer flex justify-center ${
            activeTab === "inactive" ? "active-prospects" : ""
          }`}
          onClick={() => handleTabClick("inactive")}
        >
          All
          <div
            className={`${activeTab === "inactive" ? "active-underline" : ""}`}
          ></div>
        </div>
      </Link>
    </div>
  );
};

export default TasksPage;
